import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { FileUploadComponent } from "../../common/file-upload/file-upload.component";
import { SharedComponents } from "../../shared.module";

/**
 * The `SmartTestStepperViewComponent` is responsible for managing the selection of options and files in a stepper-style form.
 * It provides functionality to track changes in dropdown selections and file uploads and aggregates all selected data.
 */
@Component({
  selector: "app-smart-test-stepper-view",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ...SharedComponents,
    FileUploadComponent,
  ],
  templateUrl: "./smart-test-stepper-view.component.html",
  styleUrl: "./smart-test-stepper-view.component.scss",
})
export class SmartTestStepperViewComponent {
  selectedOption: any;
  sectionData: any;
  files: any;

  /**
   * Constructor for the `SmartTestStepperViewComponent`. It injects the `STEP_DATA` and initializes the section data.
   * @param data - The data passed from the parent component or service (injected as "STEP_DATA").
   */
  constructor(@Inject("STEP_DATA") public data: any) {
    this.sectionData = data?.data;
  }

  /**
   * Handles the change event for the dropdown. It updates the `selectedOption` property with the selected value.
   * @param event - The event triggered when the dropdown selection changes.
   * @param data - The associated data related to the dropdown.
   */
  onDropdownChange(event: any, data: any): void {
    const target = event.target as HTMLSelectElement;
    this.selectedOption = target.value;
  }

  /**
   * Handles the selection of files. It updates the `files` property with the selected files and assigns them
   * to the `selectedFiles` property in the passed data.
   * @param event - The event triggered when files are selected.
   * @param data - The associated data where the selected files will be stored.
   */
  handleFilesSelected(event: any, data: any) {
    this.files = event.files;
    data.selectedFiles = this.files;
  }

  /**
   * Collects and logs all selected data, including selected options and files for each item in `sectionData`.
   * This method is typically called when the "Next" button is clicked in the stepper.
   */
  getAllSelectedData(): void {
    const result = this.sectionData.map((item: any) => ({
      id: item.id,
      selectedOption: item.selectedOption,
      selectedFiles: item.selectedFiles,
    }));
    console.log("All Selected Data:", result);
  }
}
